import React from "react"

import { Notification } from "@/components"
import { Button, Grid, Typography } from "@material-ui/core"
import { FileCopyOutlined as FileCopyOutlinedIcon } from "@material-ui/icons"

import { letalkLinks } from "@/utils/link"
import { mountTrackableLinkURL } from "@/utils/trackableLinks"
import { Trackablelink } from "@/protocols/trackableLinks"

import PixelLetalk from "@/pages/Admin/TrackableLinks/TrackableLinkMetrics/SetupTrackableLinkAccordion/SetupTrackableLinkSteps/PixelLetalk"

import copy from "copy-to-clipboard"
import useStyles from "@/pages/Admin/TrackableLinks/TrackableLinkMetrics/SetupTrackableLinkAccordion/SetupTrackableLinkSteps/styles"

type SetupTrackableLinkStepsProps = {
	trackableLinkToSetup: Trackablelink
}

// This string defines dynamic URL parameters for tracking advertisement performance.
// It uses template variables (e.g., {{site_source_name}}) that are replaced by the advertisement platform.
// Standard UTM parameters are included for analytics:
// - utm_source: where the traffic comes from
// - utm_medium: the advertisement placement (e.g., feed, stories)
// - utm_campaign: the name of the campaign
// - utm_content: the specific advertisement set and advertisement name
// - utm_term: repeats the placement, useful for keyword-level tracking
// Additionally, a custom parameter 'letalk_fbid' combines advertisement ID, source, and placement for internal tracking.
const URL_PARAMETERS =
"utm_source={{site_source_name}}&utm_medium={{placement}}&utm_campaign={{campaign.name}}&utm_content={{adset.name}}_{{ad.name}}&utm_term={{placement}}&letalk_fbid={{ad.id}}_{{site_source_name}}_{{placement}}"

const SetupTrackableLinkSteps: React.FC<SetupTrackableLinkStepsProps> = (props) => {
	const { trackableLinkToSetup } = props

	const classes = useStyles()
	const trackableLinkURL = mountTrackableLinkURL(trackableLinkToSetup.hash, trackableLinkToSetup.slug)

	const copyHandler = (content: string) => {
		copy(content)
		Notification.success({ message: "Copiado com sucesso!" })
	}

	return (
		<Grid container direction="column" spacing={1}>
			<Grid item>
				<Grid container direction="column" spacing={2}>
					<Grid item>
						<Typography variant="h5" className={classes.subtitle}>Passo 1</Typography>
						<Typography variant="body2">
							Clique no botão abaixo para copiar o link gerado e cole como destino do anúncio no Meta Ads.{" "}
							<a
								className={classes.link}
								href={letalkLinks.wikiHowToAddATrackableLinkAsAnAdversetimentDestinationInMetaADS}
								rel="noopener noreferrer"
								target="_blank"
							>
								Como fazer isso?
							</a>
						</Typography>
					</Grid>
					<Grid item xs={2}>
						<Button
							className={classes.button}
							fullWidth
							variant="contained"
							color="primary"
							onClick={() => copyHandler(trackableLinkURL)}
							startIcon={
								<FileCopyOutlinedIcon
									className={classes.buttonIcon}
								/>
							}
						>
							Copiar link
						</Button>
					</Grid>
				</Grid>
			</Grid>

			<Grid item>
				<Grid container direction="column" spacing={2}>
					<Grid item>
						<Typography variant="h5" className={classes.subtitle}>Passo 2</Typography>
						<Typography variant="body2">
							Clique no botão abaixo para copiar os parâmetros de URL e adicione-os dentro do Meta Ads.{" "}
							<a
								className={classes.link}
								href={letalkLinks.wikiHowToAddURLParametersWithinTheAdvertisementInMetaADS}
								rel="noopener noreferrer"
								target="_blank"
							>
								Como fazer isso?
							</a>
						</Typography>
					</Grid>
					<Grid item xs={3}>
						<Button
							className={classes.button}
							fullWidth
							variant="contained"
							color="primary"
							startIcon={
								<FileCopyOutlinedIcon
									className={classes.buttonIcon}
								/>
							}
							onClick={() => copyHandler(URL_PARAMETERS)}
						>
							Copiar parâmetros
						</Button>
					</Grid>
				</Grid>
			</Grid>

			<Grid item style={{ marginTop: 16 }}>
				<PixelLetalk />
			</Grid>
		</Grid>
	)
}

export default SetupTrackableLinkSteps
